import React, { ComponentProps, FunctionComponent } from "react";

const MicrophoneIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 10 12",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      d: "M5 0C5.51149 0 6.00203 0.199624 6.36371 0.554956C6.72538 0.910288 6.92857 1.39222 6.92857 1.89474V5.68421C6.92857 6.18673 6.72538 6.66866 6.36371 7.02399C6.00203 7.37932 5.51149 7.57895 5 7.57895C4.48851 7.57895 3.99797 7.37932 3.63629 7.02399C3.27462 6.66866 3.07143 6.18673 3.07143 5.68421V1.89474C3.07143 1.39222 3.27462 0.910288 3.63629 0.554956C3.99797 0.199624 4.48851 0 5 0M9.5 5.68421C9.5 7.91368 7.82214 9.75158 5.64286 10.0611V12H4.35714V10.0611C2.17786 9.75158 0.5 7.91368 0.5 5.68421H1.78571C1.78571 6.52174 2.12436 7.32496 2.72716 7.91718C3.32995 8.5094 4.14752 8.8421 5 8.8421C5.85248 8.8421 6.67005 8.5094 7.27284 7.91718C7.87564 7.32496 8.21429 6.52174 8.21429 5.68421H9.5Z",
    })
  );
};

const ForwardRef = React.forwardRef(MicrophoneIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
